import React from 'react';

import { STUDIO_ICONS } from 'constants/aiStudio';
import { rgmStudioCardIconTestId } from 'constants/landingTestIds';

interface Props {
    /** Registry key from the tenant's `screens[]` group. */
    icon?: string;
    groupKey: string;
}

/**
 * 40x40 colour-badge icon for a Studio card.
 *
 * Both dimensions are fixed so a missing intrinsic size cannot push the card layout around, and
 * an unknown or absent `icon` falls back to a neutral badge with no glyph rather than a broken
 * image. That fallback is what makes the feature safe to ship before every tenant config carries
 * icon keys.
 */
function StudioCardIcon({ icon, groupKey }: Props) {
    const iconDef = icon ? STUDIO_ICONS[icon] : undefined;
    const Icon = iconDef?.Icon;

    return (
        <div
            data-testid={rgmStudioCardIconTestId(groupKey)}
            className={`flex size-10 shrink-0 items-center justify-center rounded-lg ${
                iconDef?.bgClassName ?? 'bg-filterV2Border'
            }`}
        >
            {Icon && <Icon className="size-5" />}
        </div>
    );
}

export default StudioCardIcon;
